import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CMSService } from '../../../services/cms-service';
import { MedicamentLivre } from 'model/modal-cms/medicament_livre';
import Swal from 'sweetalert2'
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
declare var mdtoast: any;
var success_message = mdtoast('Opération effectué avec succès.', { duration: 5000, init: true, type: mdtoast.SUCCESS });
var error_message = mdtoast('Opération non effectué.', { duration: 5000, init: true, type: mdtoast.ERROR });
var info_message = mdtoast('Opération non effectué. Ce donnée est en cours d\'utilisation.', { duration: 5000, init: true, type: mdtoast.INFO });

@Component({
  selector: 'app-medicament-livrer',
  templateUrl: './medicament-livrer.component.html',
  styleUrls: ['./medicament-livrer.component.scss']
})
export class MedicamentLivrerComponent implements OnInit {
  listeMedLivrer: any;
  
  medicamentLivre : MedicamentLivre=new MedicamentLivre(null);
  etat: any = "A";
  responsable:any= "Mme RAJERISON Holy Tiana Valérie"
  motCle:any;
  fileToUmpload: File = null;
  imageUrl: string = "";
  urlServer = environment.urlServerphoto;

  constructor(private router: Router,public cmsService: CMSService,private http: HttpClient,) {  }

  ngOnInit() {
this.getListeMedLivrer();
  }


  openViewMedicamentLivrer(id:any){
    this.router.navigate(['view-med-livre/'+id]);  
  }

  getListeMedLivrer() {
    this.cmsService.getMedLivrer()
      .subscribe(data => {
        console.log("data milay"+data)
        this.listeMedLivrer = data
      },
        err => {
          console.log(err);
        })

  }

  getInfoMedLivrer(id_med:number) {
    this.cmsService.getInfoMedLivrer(id_med)
      .subscribe(data => {
        this.medicamentLivre = data
      },
        err => {
          console.log(err);
        })

  }


  chercherMedLivrer(mcl){
    if(mcl==""){
      this.getListeMedLivrer();
    }else {
      this.cmsService.filtrerMedLivrer(mcl)
      .subscribe(data => {
        this.listeMedLivrer = data
      },
        err => {
          console.log(err);
        })
    }
    
  }

  
    //upload  file etudiant
    onChangeSelectFile(file: FileList) {
      this.fileToUmpload = file.item(0);
      console.log(this.fileToUmpload);
      //show image preview
      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.imageUrl = event.target.result;
      }
      reader.readAsDataURL(this.fileToUmpload);     
    }

     //uplod logo IEC
   enregistrerFileMedLivrer() {   
    const uploadData = new FormData();
    uploadData.append('avatar', this.fileToUmpload, this.fileToUmpload.name);
    // http://192.168.137.116/UnivServeur/' http://localhost/ImageEtudiant/upload2.php'
    this.http.post(this.urlServer+'uploadEntrepot.php', uploadData, {
      reportProgress: true,
      observe: 'events'
    })
      .subscribe(event => {
        console.log(event);
      }
      )
  }




  SaveMedLivrer(){
    if (this.medicamentLivre.id_med_liv == null) {
      this.medicamentLivre.etat_medicament = this.etat; 
      this.medicamentLivre.resp_grand_stock = this.responsable;
      this.medicamentLivre.file_med_liv = this.fileToUmpload.name
      console.log(this.medicamentLivre);
      this.cmsService.saveMedLivrer(this.medicamentLivre).subscribe(data=>{
        if(data.err){
           //toastr.error(data.err);return;
         }          
           this.getListeMedLivrer();
           this.enregistrerFileMedLivrer();
           this.medicamentLivre = new MedicamentLivre(null)
           success_message.show();
         },err=>{ 
          error_message.show();    
         })
    }else{
        if(this.fileToUmpload==null)  {
       
         }else{
           this.medicamentLivre.file_med_liv = this.fileToUmpload.name
            this.enregistrerFileMedLivrer();
         }
      this.cmsService.updateMedLivrer(this.medicamentLivre).subscribe(data=>{
        if(data.err){
           //toastr.error(data.err);return;
         }   
           //toastr.error(data.err);return;
           this.getListeMedLivrer();
           this.medicamentLivre = new MedicamentLivre(null)
           success_message.show();
         },err=>{ 
          error_message.show();    
         })
    }
    
  }


  deleteMedLivrer(r: MedicamentLivre) {
    Swal.fire({
      title: 'Êtes-vous sûr de supprimer?',
      text: "Une fois que vous cliquez sur Ok, vous ne pouvez plus revenir en arrière.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'OK',
      cancelButtonText: 'Non'
    }).then((result) => {
      if (result.value) {
        this.cmsService.deleteMedLivrer(r.id_med_liv)
        .subscribe(data => {
          this.getListeMedLivrer();
          success_message.show();
        }, err => {
          console.log('erreur de supression');
        })
      }
    })
 }


 returSary(){
  this.router.navigate(['gestion-med']);
 }

}
